import React, { useState,useEffect } from 'react'
import { useTranslation } from 'react-i18next';
import useLoadingState from '../../../Utils/Hooks/useLodingState';
import useOverlayState from '../../../Utils/Hooks/useOverlayState';
import { useAuth } from '../../../Store/AuthContext';
import { SideDrawer } from '../../atoms/Drawer/SideDrawer';
import { useForm } from 'react-hook-form';

import { NoRecordsFound } from '../../atoms/NoRecordsFound/NoRecordsFound';
import { Autocomplete, Stack } from '@mui/material';
import { TextInput } from '../../atoms/Input/TextInput';
import { PhoneNumber } from '../../atoms/Input/PhoneNumber';
import { addLocation, getAllCityBasedOnDistrict, getAllDistrict, getAllProvince, getLocationByID, updateLocation } from '../../../Api/Location/Location.api';

import TextField from "@mui/material/TextField";
import { FormItemsWrap } from '../../molecules/Wrap/Wrap';
import Button from '@mui/material/Button';
import { LoadingButtonType } from '../../atoms/LoadingButton/LoadingButton';
import { Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { schema } from './shema';
import Label from '../../atoms/Input/Label';
import ConfirmDialog from '../ConfirmDialog/ConfirmDialog';
import { ErrorSharp } from '@mui/icons-material';

export const AddLocation = ({
  close,
  closeMain,
  data,
  OpenDrawer,
  loadLocations,
  mode,
  refetch,}) => {

  const { state } = useAuth();
  const { t } =  useTranslation();
  const { LoadingState, startLoading, stopLoading } = useLoadingState();
  const { closeOverlay, OverlayState, openOverlay } = useOverlayState();

  const [provinces, setProvinces] = useState([]);
  const [district,setDistrict] = useState([]);
  const [city,setCity] = useState([]);
  // const [provinceId,setProvinceId] = useState();
  // const [districtId,setDistrictId] = useState();
  // const [cityId,setCityId] = useState();

  const [doctorMasterData, setDoctorMasterData] = React.useState({
    selectedSpeciality: null,
  });

  // Trigger server error
  const [isError, setIsError] = useState(false)

  // State for cancel confirmation dialog
  const [showCancelConfirmation, setShowCancelConfirmation] = useState(false);

  // Set up react-hook-form with only the needed fields
  const {
    control,
    setValue,
    watch,
    setError,
    reset,
    handleSubmit,
    getValues,
  } = useForm({
    defaultValues: {
      clinicName: "",
      address: "",
      province: "",
      district: "",
      city: "",
      zipCode: "",
      email: "",
      phoneNumber:"",
      provinceId:null,
      districtId:null,
      cityId:null
    },
    mode: "onChange",
    resolver: yupResolver(schema(t)), // Schema should validate only these fields
    criteriaMode: "all",
    reValidateMode: "onChange",
  });

  // get districts base on relevant province
  const apiCallforGetDistricts = async (provinceId) => {
      const response = await getAllDistrict(provinceId);
      if (response.type === 0) {
        setDistrict(response.data)
        return response;
      } else {
        throw new Error(response.message || "Failed to fetch Location data");
      }
  };

  // get all province
  const apiCallForGetProvince = async () => {
      const response = await getAllProvince();
      if (response.type === 0) {
        setProvinces(response.data);
        return response;
      } else {
        throw new Error(response.message || "Failed to fetch Location data");
      }
  };

  // get cites based on relevant districts
  const apiCallForGetCities = async (districtId) => {
      const response = await getAllCityBasedOnDistrict(districtId);
      if (response.type === 0) {
        setCity(response.data)
        return response;
      } else {
        throw new Error(response.message || "Failed to fetch Location data");
      }
  };

  // Handler for form submission to create a doctor assistant
  const createLocationHandler = async (values) => {
      startLoading({ btnName: "create" });
      try{
        const response = await addLocation({
           clinicLocation : {
            ...values,
            // provinceId: provinceId,
            // districtId: districtId,
            // cityId: cityId
        },
        });

        if (response.type === 0){
            openOverlay({
              OverlayName: "reset-password",
              mode: "email-sent",
            });
        }
        else if (response.type === 2){
          if(response.message === "location-exist"){
            setError("clinicName",{
              message: t("Location already exists.", { ns: "validation" }),
            })
          }
          else if (response.message === "Admin creation failed"){
            setIsError(true)
          }
        }
        else{
          setIsError(true)
        }
      }
      catch (error){
        console.error("Error creating doctor assistant:", error);
        setIsError(true);
      }
      finally{
        stopLoading();
      }
  }

  // Get locations by id
  const getLocationById = async () => {
    try{
      startLoading({ btnName: "default" });

      const response = await getLocationByID({
        id: data.id,
      })
      
      if (response.type === 0){
         data = response.data;
         reset({
            clinicName: response.data.clinicNameBase,
            address: response.data.address,
            province: response.data.province,
            district: response.data.district,
            city: response.data.city,
            zipCode: response.data.zipCode,
            email: response.data.email,
            phoneNumber: response.data.phoneNumber,
            phoneNumberCountryCode: response.data.phoneNumberCountryCode, 
            phoneNumberDialCode: response.data.phoneNumberDialCode, 
            provinceId:Number(response.data.provinceID),
            districtId:Number(response.data.districtID),
            cityId:Number(response.data.cityID)
        });

      }
      stopLoading({ btnName: "default" });
    }
    catch(exception){
      console.error("Error fetching doctor assistant:", exception);
      stopLoading({ btnName: "default" });
    }
  };

  // Update Location
  const updateLocationHandler = async (values) =>{
      await updateLocation({
        clinicLocation : {
          ...values,  
          id: data.id
        },
      }).then((d) => {
        if(d.type === 0){
          openOverlay({
            OverlayName: "reset-password",
            mode: "email-sent",
          });
        }
        else if(d.type === 2){
          if(d.message === "location-exist"){
            setError("clinicName",{
              message: t("Location already exists.", { ns: "validation" }),
            })
          }
          else if (d.message === "Admin creation failed"){
            setIsError(true)
          }
        }
        else{
          setIsError(true)
        }
      })
  }

  // Handler for cancel button click
  const handleCancelClick = () => {
    setShowCancelConfirmation(true);
  };

  // Handler for confirming cancel action
  const handleConfirmCancel = () => {
    setShowCancelConfirmation(false);
    reset();
    close();
  };

  // Effect to fetch locations and populate form in update mode
  useEffect(() => {
    const fetchData = async () => {
      if (mode === "update" && data) {
        await getLocationById();
      }
    };
    fetchData();
  }, [mode, data]);


  return (
    <SideDrawer
     isLoading={LoadingState.visible}
      headingText={
        mode === "update"
          ? "Edit"
          : "New Location"
      }
      width={"690px"}
      openDrawer={OpenDrawer}
      close={close}
      anchorDrawer={"right"}
    >

    {isError && (
      <NoRecordsFound
        isError={isError}
        textPosition={"start"}
        padding={"8px"}
        textColor={"black"}
        label={"validation:server-error"}
      />
    )}

    <div style={{ paddingBottom: "20px",marginTop: "20px" }}>
      {OverlayState.visible && (
                <ConfirmDialog
                  description={
                    mode === "update"
                      ? t("Location updated successfully.")
                      : t("Location added successfully.", { ns: "glossary" })
                  }
                  open={OverlayState.visible}
                  close={() => closeOverlay()}
                  onOkClick={() => {
                    reset();
                    loadLocations();
                    close();
                    closeOverlay();
                  }}
                />
      )}

      {/* Cancel Confirmation Dialog */}
      {showCancelConfirmation && (
        <ConfirmDialog
          title={"Cancel"}
          description={"Are you sure you want to proceed?"}
          open={showCancelConfirmation}
          close={() => setShowCancelConfirmation(false)}
          onNoClick={() => setShowCancelConfirmation(false)}
          onOkTitle={"Yes"}
          onNoTitle={"No"}
          onOkClick={handleConfirmCancel}
        />
      )}

      <form
        onSubmit={handleSubmit((formData) => {
            if (mode === "update") {
              updateLocationHandler(formData);
            } else {
              createLocationHandler(formData);
            }
          })}
      >
        <Stack rowGap={"20px"} width={"640px"}>

          <TextInput
            required={true}
            name={"clinicName"}
            control={control}
            label={"Location name"}
          />

          <TextInput
            required={true}
            name={"address"}
            control={control}
            label={"Address"}
          />

          <div  
          style={{
                display: "grid",
                gridTemplateColumns: "repeat(2,1fr)",
                gap: "16px",
          }}>
            <FormItemsWrap>
              <Label label={"Province"} required={true}></Label>
              <Controller
                name="province"
                control={control}
                render={({field,fieldState}) => (
                  <Autocomplete
                    disablePortal
                    options={provinces}
                    getOptionLabel={(option) => option.province || ""}
                    onOpen={apiCallForGetProvince}
                    onChange={(event, newValue) => {
                      field.onChange(newValue?.province)
                      setValue("provinceId", newValue?.provinceId);

                    }}
                    defaultValue={{ provinceId: getValues("provinceId"), province: getValues("province") }}
                    renderInput={(params) => (
                      <TextField 
                      {...params} 
                      InputLabelProps={{ shrink: false }}
                      //placeholder="Select Province" 
                      error={!!fieldState.error} 
                      helperText={fieldState.error?.message}
                      sx={{
                          "& .MuiOutlinedInput-input": {
                            padding: "12px 54px",
                          },
                          "& .MuiInputBase-input": {
                            fontSize: "13px",
                          },
                          "& .MuiOutlinedInput-input": {
                            padding: "0 14px", 
                            height: "100%",   
                            boxSizing: "border-box",
                          },
                        }}
                      />
                    )}
                  />
                )}
              />
            </FormItemsWrap>

            <FormItemsWrap>
              <Label label={"District"} required={true}></Label>
              <Controller
                name="district"
                control={control}
                render={({field,fieldState}) => (
                  <Autocomplete
                  disablePortal
                  options={district}
                  getOptionLabel={(option) => option.district || ""}
                  onOpen={() => apiCallforGetDistricts(getValues("provinceId"))}  
                  disabled = {
                    // !provinceId && mode != "update"
                    getValues("provinceId") == null && mode != "update"
                  }
                  onChange={(event, newValue) =>{
                    field.onChange(newValue?.district)
                    //setDistrictId(newValue?.districtId);
                    setValue("districtId", newValue?.districtId);

                  }}
                  defaultValue={{ districtId: getValues("districtId"), district: getValues("district") }}
                  renderInput={(params) => <TextField 
                    {...params} 
                    //placeholder="Select District"
                    error={!!fieldState.error} 
                    helperText={fieldState.error?.message} 
                    InputLabelProps={{ shrink: false }}
                    sx={{
                          "& .MuiOutlinedInput-input": {
                            padding: "12px 54px",
                          },
                          "& .MuiInputBase-input": {
                            fontSize: "13px",
                          },
                          "& .MuiOutlinedInput-input": {
                            padding: "0 14px", 
                            height: "100%",   
                            boxSizing: "border-box",
                          },
                        }}
                    />}
                  />
                )}
              />
            </FormItemsWrap>

          </div>

          <div  
          style={{
                display: "grid",
                gridTemplateColumns: "repeat(2,1fr)",
                gap: "16px",
          }}>

            <FormItemsWrap>
              <Label label={"City"} required={true}></Label>
              <Controller
                name="city"
                control={control}
                render={({field,fieldState}) => (
                  <Autocomplete disablePortal
                  options={city}
                  getOptionLabel={(option) => option.city|| ""}
                  onOpen={() => apiCallForGetCities(getValues("districtId"))}  
                  disabled = {
                    // !districtId && mode != "update"
                    getValues("districtId") == null && mode != "update"
                  }
                  onChange={(event, newValue) =>{
                    field.onChange(newValue?.city)
                    //setCityId(newValue?.cityId);
                    setValue("cityId",newValue?.cityId)
                  }}
                  defaultValue={{ cityId: getValues("cityId"), city: getValues("city") }}
                  renderInput={(params) => <TextField 
                    {...params} 
                    //placeholder="Select City"
                    error={!!fieldState.error} 
                    helperText={fieldState.error?.message}
                    InputLabelProps={{ shrink: false }}
                    sx={{
                          "& .MuiOutlinedInput-input": {
                            padding: "12px 54px",
                          },
                          "& .MuiInputBase-input": {
                            fontSize: "13px",
                          },
                          "& .MuiOutlinedInput-input": {
                            padding: "0 14px", 
                            height: "100%",   
                            boxSizing: "border-box",
                          },
                        }}
                    
                    />}
              />
                )}
              />
            </FormItemsWrap>

            <TextInput
              required={false}
              name={"zipCode"}
              control={control}
              label={"Zip code"}
            />

          </div>

          <div  style={{display: "grid", gridTemplateColumns: "repeat(2,1fr)", gap: "16px",}}>

              {/* Email Input */}
              <TextInput
                required={false}
                name={"email"}
                placeholder={"youremail@address.com"}
                control={control}
                label={"Email"}
                //disabled={isDisabled}
              />

              {/* Mobile / Phone Number Input */}
              <PhoneNumber
                values={watch()}
                setValue={setValue}
                required={true}
                width={"220px"}
                name={"phoneNumber"}
                placeholder={"XX XXXX XXXX"}
                control={control}
                label={"Phone no."}
                //disabled={isDisabled}
              />

          </div>

           <FormItemsWrap
              direction={"row"}
              justifyContent={"flex-end"}
              gap={"16px"}
            >
              <Button variant="whiteSquare" onClick={handleCancelClick}>
                {"Cancel"}
              </Button>
              <LoadingButtonType
                variant="primaryBlue"
                type="submit"
                loading={LoadingState.visible}
              >
                {mode === "update"
                  ? "Save"
                  : "Add"}
              </LoadingButtonType>
            </FormItemsWrap>
          
        </Stack>
      </form>
    </div>

    </SideDrawer>
  )
}